import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    INITIATE
} from 'one-state-screenpop/src/types';

import {
    setStatus
} from 'one-state-screenpop/src/actions';

import {
    ScreenpopModel
} from 'one-state-screenpop/src/model';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToStatus = (payload: any) => setStatus(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will intiate screenpop via get method to
 *  backend api and returns status
 * @param context contains the settings etc..
 */
export const fetchScreenpopEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, agentId, alertnotification, teamName, log, settings: { servers, compatible, epicendpoints } } = context;
        const { contact_center_type, finesse_proxy_service } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(INITIATE),
            // ofType(Types.PatientSet),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let dataresponse: ScreenpopModel = action.payload;
                const getRequest = (payload: ScreenpopModel) => {
                    let response;
                    if (finesse_proxy_service) {
                        console.log('INSIDE Screenpop')
                        response = InvokeFinesseProxy(epicendpoints.screenpop +
                                                        "?agentId=" + payload.agentId +
                                                        "&location=" + payload.location +
                                                        "&patientId=" + payload.patientId +
                                                        "&activityId=" + payload.activityId +
                                                        "&eventType=Epic", 
                                                        "", epicendpoints.apitoken, locations, log, 'POST', alertnotification);

                    } else {
                    //ADPAC-349
                     response = server.post({
                        path: epicendpoints.screenpop +
                            "?agentId=" + payload.agentId +
                            "&location=" + payload.location +
                            "&patientId=" + payload.patientId +
                            "&activityId=" + payload.activityId +
                            "&eventType=Epic"
                    })
                        .then((responsefound: any) => {
                            // treating as success for screenpop
                            let responsescreenpopfound = { "status": 200 };
                            log.debug(
                                "ccw-gadget,screenpop-epic",
                                "screenpop-epic response", {
                                    responsescreenpopfound
                            });
                            let result = responsescreenpopfound;
                            return result;
                        })
                        .catch((responseresult: any) => {
                            log.error(
                                "ccw-gadget,screenpop-epic",
                                "screenpop-epic", {
                                responseresult
                            }
                            );
                             let result = responseresult;
                             return result;
                        })
                    }
                    return from(response)

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => response)
                    ).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                pushToStatus(response)
                            ];

                            let disp: Disposition = { value: dataresponse.from };
                            disp.meta00 = agentId;
                            if (contact_center_type && contact_center_type === "five9") {
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta01 = skillName;
                            }
                            else {
                                disp.meta01 = teamName;
                            }
                            disp.meta02 = dataresponse?.patientId;
                            disp.meta03 = dataresponse?.activityId;
                            actions.push(pushToDisposition(disp));

                            //Disposition Framework
                            if (response && response?.status && response?.status == 200) {
                                let disp: Disposition = { value: "174" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.activityId;
                                disp.meta03 = dataresponse?.patientId;
                                disp.meta04 = dataresponse?.location;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "989" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.activityId;
                                disp.meta03 = dataresponse?.patientId;
                                disp.meta04 = dataresponse?.location;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            if (response?.errors && response?.errors?.length > 0) {
                                /*changes for errors will pushed to bell icon*/
                                let errorbuild: ErrorObject = {
                                    source: "Screenpop",
                                    type: "error",
                                    status: response?.status,
                                    erroritems: response?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                actions.push(addAction(errorbuild))
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
